import React from 'react';
import {FormControl, FormControlLabel} from 'material-ui/Form';
import Radio, {RadioGroup} from 'material-ui/Radio';
import {Link} from 'react-router';

const Feedback = ({feedback, questions, onChange, onSubmit, showPopup, webinarId}) => {

  return (
    <main className="site--width">
      <div className="feedback_form">
        <div className="feedback_form_container_title">
          <div className="feedback_form_title">Evaluation Form</div>
          {/*<div className="feedback_form_underline"></div>*/}
        </div>
        {questions.map((item) => (
          <div className="feedback_answer_block">
            {item.topic && <div className="feedback_form_description">{item.topic}</div>}
            {item.question && <div className="feedback_question">{item.question}</div>}
            {item.answers && <div className="form-box-feedback">
              <FormControl>
                <RadioGroup
                  name={item.question}
                  value={feedback[item.question]}
                  onChange={e => {
                    onChange(item, e)
                  }}
                  row
                >
                  {item.min && <p className="low_grading"> {item.min} </p>}
                  {item.answers.map((answer) => (
                    <FormControlLabel
                      value={answer}
                      control={<Radio color="primary"/>}
                      label={answer}
                    />
                  ))}
                  {item.max && <p className="low_grading"> {item.max} </p>}
                </RadioGroup>
              </FormControl>
            </div>}
            {item.text && <div className="texteria_feedback">
              <textarea placeholder={item.text} name={item.text} onChange={e => onChange(item, e)}></textarea>
            </div>}
          </div>
        ))}

        <div className="button_submit">
          <button className="submit_feedback" onClick={onSubmit}>Submit Feedback</button>
        </div>
      </div>
      {showPopup && (
        <div>
          <div className="feedback-popup-container">
          </div>
          <div className="feedback-popup">
            <div className="feedback-popup-description">
              Thank you for your feedback
            </div>
            <div className="feedback-popup-title">
              Your feedback helps us to improve our content offering on MedCafe
            </div>
            <div className="feedback-popup-button">
              <Link className="back-to-webinars" activeClassName={'active'} to={`/webinars/${webinarId}`}>
                Close
              </Link>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/components/Feedback/Feedback.jsx